import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sale-configuration-form',
  templateUrl: './sale-configuration-form.component.html',
  styleUrls: ['./sale-configuration-form.component.scss']
})
export class SaleConfigurationFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
